// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-assets_bullitttime-uploader_js-node_modules_dayjs_locale_af_js-node_modules_dayjs_loc-2ea758","node_modules_embroider_babel-loader-9_index_js_variant_name_dev_runtime_browser_optimizeForPr-f11615"], () => (__webpack_require__("./assets/bullitttime-uploader.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
